module.exports = __webpack_public_path__ + "static/img/tx2-b.b0efdd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx2-b.png
// module id = 1alT
// module chunks = 1